export default '/pricing/tier/payment';
